(() => {
  const initializeVideoStoryDS = (scopeDS = document) => {
    scopeDS.querySelectorAll('[data-video-story-ds]').forEach((sectionDS) => {
      if (sectionDS.dataset.initialized === 'true') return;

      const autoplayVideoDS = sectionDS.querySelector('.videoStoryDS__autoplay');
      if (autoplayVideoDS) {
        autoplayVideoDS.muted = true;
        autoplayVideoDS.defaultMuted = true;
        autoplayVideoDS.loop = true;
        autoplayVideoDS.playsInline = true;
        autoplayVideoDS.play().catch(() => {});
        autoplayVideoDS.addEventListener('ended', () => {
          autoplayVideoDS.currentTime = 0;
          autoplayVideoDS.play().catch(() => {});
        });
      }

      const openDS = sectionDS.querySelector('[data-video-story-ds-open]');
      const closeDS = sectionDS.querySelector('[data-video-story-ds-close]');
      const dialogDS = sectionDS.querySelector('[data-video-story-ds-dialog]');
      if (!openDS || !closeDS || !dialogDS) {
        sectionDS.dataset.initialized = 'true';
        return;
      }

      const stopVideoDS = () => {
        const videoDS = dialogDS.querySelector('video');
        const iframeDS = dialogDS.querySelector('iframe');

        if (videoDS) {
          videoDS.pause();
          videoDS.currentTime = 0;
        }

        if (iframeDS) {
          const sourceDS = iframeDS.src;
          iframeDS.src = '';
          iframeDS.src = sourceDS;
        }
      };

      const closeDialogDS = () => {
        stopVideoDS();
        dialogDS.close();
      };

      openDS.addEventListener('click', () => {
        dialogDS.showModal();
        dialogDS.querySelector('video')?.play().catch(() => {});
      });

      closeDS.addEventListener('click', closeDialogDS);
      dialogDS.addEventListener('click', (eventDS) => {
        if (eventDS.target === dialogDS) closeDialogDS();
      });
      dialogDS.addEventListener('cancel', stopVideoDS);

      sectionDS.dataset.initialized = 'true';
    });
  };

  initializeVideoStoryDS();
  document.addEventListener('shopify:section:load', (eventDS) => initializeVideoStoryDS(eventDS.target));
})();
